// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xProductListStateType = Readonly<{
    isProductListFilterModalOpen?: boolean;
    isLoadingRealTimeInventory?: boolean;
}>;

export const initialxProductListState: xProductListStateType = {
    isProductListFilterModalOpen: false,
    isLoadingRealTimeInventory: false,
};

const reducer = {
    "xProductList/isProductListFilterModalOpen": (draft: Draft<xProductListStateType>, action: { isOpen: boolean }) => {
        draft.isProductListFilterModalOpen = action.isOpen;
    },
    "xProductList/isLoadingRealTimeInventory": (draft: Draft<xProductListStateType>, action: { isLoadingRealTimeInventory: boolean }) => {
        draft.isLoadingRealTimeInventory = action.isLoadingRealTimeInventory;
    },
};

const xProductList = createTypedReducerWithImmer(initialxProductListState, reducer);

(reducers as any).xProductList = xProductList;

export type xProductListState = {
    xProductList: xProductListStateType;
} & ApplicationState;

type xProductListReducers = {
    [key: string]: typeof xProductList;
};

export type xProductListActions = Parameters<xProductListReducers[keyof xProductListReducers]>[1] | AnyAction;
